import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="0.25"
        y="0.25"
        width="71.5"
        height="71.5"
        rx="1.75"
        fill="#CCCCCC"
        stroke="#A5A5A5"
        strokeWidth="0.5"
      />
      <g filter="url(#filter0_d)">
        <rect x="8" y="9" width="56" height="56" rx="2" fill="#E6E6E6" />
      </g>
      <path d="M36 9V65" stroke="#C9C9C9" />
    </Svg>
  );
};

export default Icon;
